import React from 'react'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

export type InsightsFilters = {
  genders?: (string | null)[]
  legalEntities?: string[]
  workplaces?: string[]
  managers?: (string | null)[]
  teams?: string[]
  nationalities?: (string | null)[]
}

export const useInsightsFilters = () => {
  const [filters, setFilters] = React.useState<InsightsFilters>({})

  const setFilter = useUnsafeCallback(
    <T extends keyof InsightsFilters>(filterType: T, newFilter: InsightsFilters[T]) => {
      setFilters((oldFilters) => {
        return {
          ...oldFilters,
          // Empty arrays stored as undefined, to simplify logic
          [filterType]: newFilter?.length ? newFilter : undefined,
        }
      })
    },
    [setFilters]
  )

  const clearFilters = useUnsafeCallback(() => {
    setFilters({})
  }, [setFilters])

  return {
    filters,
    setFilter,
    clearFilters,
  }
}
